import { render, staticRenderFns } from "./NetaAttractionDetailsMenuComponent.vue?vue&type=template&id=0e7bc966&scoped=true&"
import script from "./NetaAttractionDetailsMenuComponent.vue?vue&type=script&lang=js&"
export * from "./NetaAttractionDetailsMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaAttractionDetailsMenuComponent.vue?vue&type=style&index=0&id=0e7bc966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7bc966",
  null
  
)

export default component.exports